import { getTrimId } from '../utils/index.tsx';
import { type Filter, ACTIVE } from './types.tsx';

export const getAssociateFieldToScreensUrl = (id: string) =>
	`/secure/admin/AssociateFieldToScreens!default.jspa?fieldId=${id}`;

export const getScreenUrl = (screenId: number) =>
	`/secure/admin/ConfigureFieldScreen.jspa?id=${screenId}`;

export const getTranslateCustomFieldUrl = (id: string) =>
	`/secure/admin/TranslateCustomField!default.jspa?id=${getTrimId(id)}`;

export const getConfigureCustomFieldUrl = (id: string) =>
	`/secure/admin/ConfigureCustomField!default.jspa?customFieldId=${getTrimId(id)}`;

export const getEditCustomFieldUrl = (id: string) =>
	`/secure/admin/EditCustomField!default.jspa?id=${getTrimId(id)}`;

export const getDeleteCustomFieldUrl = (id: string) =>
	`/secure/admin/DeleteCustomField!default.jspa?id=${getTrimId(id)}`;

export const defaultQuery: Filter = {
	searchFilter: undefined,
	customFieldStatus: ACTIVE,
};

export const ITEMS_PER_PAGE = 15;

export const CUSTOM_FIELDS_TYPE = 'custom';

export const ATLASSIAN_TEAM_CF_TYPE =
	'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
